import { BarSeries } from 'react-stockcharts/lib/series';
import React from 'react';
import { THEMES } from './../../../configs/LayoutConfig';

export default function(props) {
  const { theme } = props;
  const barColorCf = {
    Dark: '#376691',
    Light: '#2c73e8',
    Classic: '#376691',
  };
  const barColor = barColorCf[theme];
  return (
    <BarSeries
      yAccessor={props.yAccessor}
      opacity={1}
      widthRatio={1}
      fill={barColor}
    />
  );
}
